import React, { useMemo } from 'react';

import dayjs from 'dayjs';

import { Badge, Flex, Timeline } from 'antd';
import locale from 'dayjs/locale/pt-br';
import { useNavigate } from 'react-router-dom';
import { WidgetTitle } from 'src/pages/dashboard/styles';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import {
	DatetimeLabel
} from 'src/pages/dashboard/components/OccurrencesTimeline/styles';
import _ from 'lodash';

dayjs.locale(locale);

export default function OccurrencesTimeline() {
	const navigate = useNavigate();
	const { occurrences, } = useOccurrences();

	const items = useMemo(() => {
		const lastOccurrences = occurrences
			.filter(occ => !occ.is_recovery)
			.sort((a, b) => {
				return dayjs(b.creation_date).valueOf() - dayjs(a.creation_date).valueOf();
			})
			.slice(0, 7);

		return lastOccurrences.map(occ => {
			const datetime = occ.creation_date;
			const formattedDatetime = dayjs(datetime)
				.format('DD MMM YYYY, HH:mm');

			const hasRecovery = occurrences.some(_occ => 
				_occ.observer_id === occ.observer_id && _occ.is_recovery &&
					new Date(_occ.creation_date) > new Date(occ.creation_date)
			);

			return {
				color: occ.observer.severity.color,
				children: <Flex
					style={{ cursor: 'pointer', }}
					title={occ.preview_message}
					gap={4}
					vertical
					align='start'
					onClick={() => {
						navigate(`/occurrence/${occ.ocurrence_id}`);
					}}
				>
					<Badge dot={hasRecovery} color='green'>
						{
							occ.preview_message.length > 36
								? occ.preview_message.substring(0, 33) + '...'
								: occ.preview_message
						}
					</Badge>
					<DatetimeLabel>
						{formattedDatetime}
					</DatetimeLabel>
				</Flex>,
			};
		});
	}, [ occurrences, ]);

	return (
		<Flex vertical gap={16}>
			<WidgetTitle>
                Histórico de ocorrências
			</WidgetTitle>
			<Timeline items={items} />
		</Flex>
	);
}
